import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PortalService } from "@app/modules/home/services/portal.service";
import { GoogleAnalyticServiceService } from "@helpers/google-analytic-service.service";

@Directive({
  selector: "[appGATrackPath]",
})
export class GATrackPathDirective implements OnInit {
  constructor(
    private googleAnalyticService: GoogleAnalyticServiceService,
    private portalService: PortalService,
    private route: ActivatedRoute,
    private el: ElementRef
  ) {}

  @Input("appGATrackPath") path: string;
  @Input() screen: string;
  private routeData;

  ngOnInit() {
    this.routeData = this.route.snapshot.data;
  }

  @HostListener("click", ["$event"]) onClick($event) {
    this.trackGA(this.path, this.screen);
  }

  trackGA(path, screen) {
    if (screen === "Portal") {
      this.portalService.setRouteFlow(path);
    }
    this.googleAnalyticService.googleTaskManagerPush({
      event: "appScreenView",
      screenName: this.routeData.title.replace("-", `- ${screen}`),
      screenPath: path,
    });
  }
}
